$(document).ready(function(){
   $('.humberg-icon-desk .icon-line i.fa-bars').click(function(){
      $('.header-desk-menu').addClass('header-desk-menu-open');
     $('.humberg-icon-desk .icon-line').addClass('menu-open')
 });
     $('.humberg-icon-desk .icon-line i.fa-xmark').click(function(){
      $('.header-desk-menu').removeClass('header-desk-menu-open');
     $('.humberg-icon-desk .icon-line').removeClass('menu-open')
 });
});
$(document).on('click','.btn-checkout',function(){
    if($('#hc-gdpr-check-a').is(':checked')){
      // console.log('checked');
      window.location = '/checkout';
      return true;
    }else{
      // console.log('unchecked');
      alert('Please accept terms and conditions');
      window.location = '#';
      return false;
    }
  });

              
                // Save note anytime it's changed
                $(document.body).on('change', '#CartSpecialInstructions', function() {
                  var newNote = $(this).val();
                      
                  // Update the cart note in case they don't click update/checkout
                  $.ajax({
                    type: 'POST',
                    url: '/cart/update.js',
                    data: 'note=' +newNote,
                    dataType: 'json',
                    success:function( cart ) {
                      console.log('cart=',cart);
                    },
                    error: function(XMLHttpRequest, textStatus) {
                      console.log(XMLHttpRequest, textStatus);
                    },
                    complete: function() {
                    }
                  });
                });
             
             
